module.exports = __webpack_public_path__ + "static/media/imfs.aa6c78fb.png";